<template>
    <footer class="footer-wrapper footer-layout1 shape-mockup-wrap">
        <div class="shape-mockup footer-bg-shape1-1 jump" style="top: 0px; left: 0px;">
            <!-- <img src="assets/img/shape/footer-bg-shape1-1.png" alt="img"> -->
        </div>
        <div class="shape-mockup footer-bg-shape1-2 jump-reverse" style="top: 15%; right: 0px;">
            <img src="assets/img/shape/footer-bg-shape3.png" alt="img">
        </div>
        <div class="shape-mockup footer-bg-shape1-3 jump" style="right: 0px; bottom: 0px;">
            <div class="color-masking2">
                <div class="masking-src bg-mask" style="mask-image: url('assets/img/shape/footer-bg-shape1-2.png');"></div>
                <img src="assets/img/shape/footer-bg-shape1-2.png" alt="img">
            </div>
        </div>
        <div class="widget-area space-top">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget footer-widget">
                            <div class="th-widget-about">
                                <div class="about-logo">
                                    <a href="index.html"><img src="assets/img/cyanlogowhite.png" alt="CYAN"></a>
                                </div>
                                <p class="about-text mb-3 text-white">{{ $t('footer.explore') }}</p>
                                <div class="info-card style2">
                                    <div class="box-icon">
                                        <i class="fal fa-phone text-warning"></i>
                                    </div>
                                    <div class="box-content">
                                        <p class="box-text text-white">{{ $t('footer.call_us') }}</p>
                                        <h4 class="box-title"><a href="tel:16336547896">+163-3654-7896</a></h4>
                                    </div>
                                </div>
                                <div class="info-card style2">
                                    <div class="box-icon">
                                        <i class="fal fa-envelope-open text-warning"></i>
                                    </div>
                                    <div class="box-content">
                                        <p class="box-text text-white">{{ $t('footer.email_us') }}</p>
                                        <h4 class="box-title"><a href="mailto:info@cyan.com">info@cyan.com</a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">{{ $t('footer.quick_links') }}</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="tickets.html">{{ $t('footer.my_tickets') }}</a></li>
                                    <li><a href="https://maps.app.goo.gl/Gjnrhe9p9oVcAQ5x6" target="_blank">{{ $t('footer.our_location') }}</a></li>
                                    <li><a href="/working-hours">{{ $t('footer.working_hours') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">{{ $t('footer.more_links') }}</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="map.html">{{ $t('footer.cyan_map') }}</a></li>
                                    <li><RouterLink to="/terms-and-condition">{{ $t('footer.terms_conditions') }}</RouterLink></li>
                                    <li><a href="/privacy-policy">{{ $t('footer.privacy_policy') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-auto">
                        <div class="widget widget_nav_menu footer-widget">
                            <h3 class="widget_title">{{ $t('footer.user_options') }}</h3>
                            <div class="menu-all-pages-container">
                                <ul class="menu">
                                    <li><a href="cyan-profile.html">{{ $t('footer.cyan_profile') }}</a></li>
                                    <li><a href="delete-account.html">{{ $t('footer.delete_account') }}</a></li>
                                    <li><a href="logout.html">{{ $t('footer.logout') }}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Social Media Links -->
        <div class="social-media-wrap">
            <div class="container">
                <div class="social-media-content">
                    <div class="social-text">{{ $t('footer.follow_us') }}</div>
                    <div class="social-links">
                        <a href="https://www.facebook.com/cyanwpark?mibextid=LQQJ4d" target="_blank" class="social-link">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://www.instagram.com/cyanwaterpark/#" target="_blank" class="social-link">
                            <i class="fab fa-instagram"></i>
                        </a>
                        <a href="https://twitter.com/x/migrate?tok=7b2265223a222f6379616e77617465727061726b3f733d323126743d314a494f454d42657534345447394e45764148677451222c2274223a313733383530323239317d0c8285774d1a2e429e55b2532c81d89f" target="_blank" class="social-link">
                            <i class="fab fa-twitter"></i>
                        </a>
                        <a href="https://t.snapchat.com/pbYla93U" target="_blank" class="social-link">
                            <i class="fa-brands fa-square-snapchat"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-wrap bg-theme text-center">
            <div class="container">
                <p class="copyright-text">Copyright 2025 <a href="index.html">CYAN Waterpark.</a> {{ $t('footer.all_rights_reserved') }}</p>
            </div>
        </div>
    </footer>
</template>

<script setup>
</script>

<style scoped>
.footer-wrapper {
    position: relative;
    z-index: 10;
}

.shape-mockup {
    position: absolute;
    z-index: 1;
}

.widget-area {
    position: relative;
    z-index: 5;
}

.copyright-wrap {
    position: relative;
    z-index: 5;
}

/* Add this CSS for all links */
a {
    color: white;
    text-decoration: none;
}

a:hover {
    color: lightgray;
    text-decoration: none;
}

/* Social Media Styles */
.social-media-wrap {
    background: rgba(255, 255, 255, 0.05);
    padding: 20px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.social-media-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.social-text {
    color: white;
    font-size: 1.1rem;
    font-weight: 500;
}

.social-links {
    display: flex;
    gap: 15px;
    align-items: center;
}

.social-link {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 18px;
    transition: all 0.3s ease;
}

.social-link:hover {
    transform: translateY(-3px);
    background: #EFB036;
    color: white;
}

/* Specific social media hover colors */
.social-link:hover .fa-facebook-f {
    color: #ffffff;
}

.social-link:hover .fa-instagram {
    color: #ffffff;
}

.social-link:hover .fa-twitter {
    color: #ffffff;
}

.social-link:hover .fa-youtube {
    color: #ffffff;
}

.social-link:hover .fa-tiktok {
    color: #ffffff;
}

/* Widget Styles */
.widget_title {
    color: white;
    margin-bottom: 20px;
    font-size: 1.2rem;
    font-weight: 600;
}

.menu {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu li {
    margin-bottom: 10px;
}

.menu li {
    margin-bottom: 12px;
}

.menu a {
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 5px;
}

.menu a:hover {
    color: #EFB036;
    transform: translateX(8px);
}

/* Info Card Styles */
.info-card {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
}

.box-icon {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-content {
    flex: 1;
}

.box-text {
    margin: 0;
    opacity: 0.8;
    font-size: 0.9rem;
}

.box-title {
    margin: 5px 0 0;
    font-size: 1.1rem;
}

.box-title a {
    color: #EFB036;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .social-media-content {
        flex-direction: column;
        gap: 15px;
    }

    .social-link {
        width: 35px;
        height: 35px;
        font-size: 16px;
    }

    .widget-area {
        padding: 40px 0;
    }

    .widget {
        margin-bottom: 30px;
    }
}

/* RTL Support */
[dir="rtl"] .menu a:hover {
    transform: translateX(-8px);
}

[dir="rtl"] .info-card {
    flex-direction: row-reverse;
}
</style>